import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import ElementComponent from '../../../Component/UI/Element';
import { Tween, Easing } from '@tweenjs/tween.js';
import Renderable from '../../../Component/Renderable';
import { delay } from '../../../Utility/Task/TaskQueue';
import MaskComponent from '../../../Component/UI/Mask';

export class ShopMenu extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        // Scale and rotate item from special offer.
        meta.special.forEach((item: GameObject, index: number) => {
            this.specialItem(item, index * 100);
        });

        // Rotate and show offers.
        for (let offer of meta.offers) {
            yield* this.flip(offer);
        }

        // Unroll special offer banner.
        const banner: MaskComponent = meta.banner.getComponent(MaskComponent);
        const tweenMask: Tween = this.getTween(banner.offset);
        tweenMask
            .to({ left: 0, right: 0 }, 600)
            .easing(Easing.Quadratic.In)
            .start(this.elapsedTime);

        while (true) yield;
    }

    private specialItem(item: GameObject, delay: number): void {
        const elem: ElementComponent = item.getComponent(ElementComponent);
        elem.layout.scale = [0, 0];

        const tweenScale: Tween = this.getTween(elem.layout.scale);
        tweenScale
            .to({ 0: 1, 1: 1 }, 600)
            .easing(Easing.Elastic.Out)
            .delay(delay)
            .start(this.elapsedTime);

        const shine: ElementComponent = item
            .find('shine')
            .getComponent(ElementComponent);
        shine.layout.angle = 0;
        const tweenRotation: Tween = this.getTween(shine.layout);
        tweenRotation
            .to({ angle: 360 }, 5000)
            .repeat(Infinity)
            .start(this.elapsedTime);
    }

    private *flip(offer: GameObject): IterableIterator<number> {
        const element: ElementComponent = offer.getComponent(ElementComponent);

        const tween: Tween = this.getTween(element.layout.scale);
        tween
            .to({ 0: 1 }, 800)
            .easing(Easing.Exponential.Out)
            .start(this.elapsedTime);

        yield* delay(50);

        offer.children.forEach(child => {
            child.getComponent(Renderable).visible = true;
        });
    }
}
